import React, { useEffect, useRef } from "react";
import "altcha";
import { ICaptchaProvider, CaptchaProps } from "./ICaptchaProvider";

const AltchaComponent: React.FC<CaptchaProps> = ({ onToken }) => {
  const widgetRef = useRef<any>(null);

  // 🔎 Log manual do challenge
  useEffect(() => {
    fetch("http://localhost:7088/api/captcha/challenge")
      .then(res => res.json())
      .then(data => {
        console.log("🧩 ALTCHA challenge recebido:", data);
      })
      .catch(err => {
        console.error("❌ Erro ao buscar challenge:", err);
      });
  }, []);

  // 🔎 Log de eventos ALTCHA
  useEffect(() => {
    const log = (e: any) =>
      console.log("📣 ALTCHA EVENT:", e.type, e.detail);

    window.addEventListener("altcha-verified", log);
    window.addEventListener("altcha-error", log);
    window.addEventListener("altcha-challenge", log);

    return () => {
      window.removeEventListener("altcha-verified", log);
      window.removeEventListener("altcha-error", log);
      window.removeEventListener("altcha-challenge", log);
    };
  }, []);

  // ✅ Captura do token correto
  useEffect(() => {
    const widget = widgetRef.current;
    if (!widget) return;

    const handler = (event: CustomEvent) => {
      console.log("✅ altcha-verified payload:", event.detail);
      if (event.detail?.solution) {
        onToken(event.detail.solution);
      }
    };

    widget.addEventListener("altcha-verified", handler);
    return () => widget.removeEventListener("altcha-verified", handler);
  }, [onToken]);

  return (
    <altcha-widget
      ref={widgetRef}
      challengeurl="http://localhost:7088/api/captcha/challenge"
      auto="onload"
      style={{ width: "100%" }}
    />
  );
};

export const AltchaProvider: ICaptchaProvider = {
  Component: AltchaComponent,
};
